const inoTypes = {
  MyINOs : 'Add NFT',
  Normal: 'Join',
  Joined: 'Check Joined INO',
  Executable: 'Execute Giveaway',
  Past: 'Go to INO Page'
};

export default inoTypes;